import { render, staticRenderFns } from "./configurationThirdAdd.vue?vue&type=template&id=78b47f87&scoped=true&"
import script from "./configurationThirdAdd.vue?vue&type=script&lang=js&"
export * from "./configurationThirdAdd.vue?vue&type=script&lang=js&"
import style0 from "./configurationThirdAdd.vue?vue&type=style&index=0&id=78b47f87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b47f87",
  null
  
)

export default component.exports